import { Expose } from 'class-transformer';

export default class ContractAgreementFormError {
    practice_id: string[] = []
    nurse_id: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}